import { StyleSheet } from '@react-pdf/renderer';

// PDF Styles matching the Material-UI design
export const pdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 30,
    fontFamily: 'Helvetica',
    paddingBottom: 0,
  },
  pdfHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 30,
    paddingBottom: 15,
    borderBottom: '1px solid #e0e0e0',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerLogo: {
    width: 40,
    height: 40,
    marginRight: 12,
  },
  headerBrand: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#000000',
  },
  headerRight: {
    alignItems: 'flex-end',
  },
  headerInfoRow: {
    fontSize: 10,
    color: '#666666',
    marginBottom: 3,
    textAlign: 'right',
  },
  headerTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#333333',
    marginBottom: 3,
    textAlign: 'right',
  },
  header: {
    marginBottom: 30,
    textAlign: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 14,
    color: '#666666',
    lineHeight: 1.5,
  },
  section: {
    marginBottom: 20,
  },
  card: {
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: 16,
    marginBottom: 16,
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    breakInside: 'avoid',
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#333333',
    marginBottom: 12,
  },
  metricCardTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#333333',
    marginBottom: 8,
    textAlign: 'center',
  },
  cardContent: {
    fontSize: 12,
    color: '#555555',
    lineHeight: 1.4,
  },
  contentPreview: {
    backgroundColor: '#ffffff',
    border: '1px solid #eff3f4',
    borderRadius: 8,
    padding: 16,
    marginBottom: 20,
    breakInside: 'avoid',
  },
  postHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#1976d2',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  avatarText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: 600,
  },
  userInfo: {
    flex: 1,
  },
  userInfoTop: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  userName: {
    fontSize: 14,
    fontWeight: 600,
    color: '#333333',
    marginRight: 4,
  },
  verifiedBadge: {
    color: '#1DA1F2',
    fontSize: 12,
    marginRight: 4,
  },
  userHandle: {
    fontSize: 12,
    color: '#666666',
    marginRight: 4,
  },
  timestamp: {
    fontSize: 12,
    color: '#666666',
  },
  moreOptions: {
    color: '#666666',
    fontSize: 16,
  },
  postContent: {
    fontSize: 15,
    color: '#333333',
    lineHeight: 1.4,
    marginBottom: 16,
  },
  postImage: {
    width: '100%',
    maxHeight: 180,
    borderRadius: 16,
    marginBottom: 16,
    border: '1px solid #eff3f4',
    objectFit: 'cover',
  },
  postStats: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    color: '#666666',
  },
  statItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  statIcon: {
    fontSize: 18,
    marginRight: 6,
  },
  statNumber: {
    fontSize: 12,
    color: '#666666',
  },
  statLabel: {
    fontSize: 10,
    color: '#666666',
    marginRight: 16,
  },
  gridContainer: {
    flexDirection: 'row',
    marginBottom: 20,
  },
  gridItem: {
    flex: 1,
    marginRight: 16,
  },
  gridItemLast: {
    flex: 1,
    marginRight: 0,
  },
  metricCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    padding: 12,
    alignItems: 'center',
    textAlign: 'center',
    height: 160,
    justifyContent: 'space-between',
  },
  metricValue: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 4,
  },
  metricLabel: {
    fontSize: 10,
    color: '#666666',
    textAlign: 'center',
  },
  sentimentBreakdown: {
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 12,
    flex: 1,
  },
  sentimentItem: {
    alignItems: 'center',
    flex: 1,
  },
  sentimentColor: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginBottom: 3,
  },
  sentimentText: {
    fontSize: 8,
    color: '#666666',
    textAlign: 'center',
    lineHeight: 1.2,
  },
  analysisSection: {
    marginTop: 4,
  },
  analysisSubtitle: {
    fontSize: 14,
    fontWeight: 600,
    color: '#333333',
    marginBottom: 6,
  },
  analysisText: {
    fontSize: 12,
    color: '#555555',
    lineHeight: 1.3,
    marginBottom: 6,
    marginLeft: 8,
  },
  chipContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 6,
  },
  chip: {
    backgroundColor: '#e3f2fd',
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginRight: 6,
    marginBottom: 6,
  },
  chipText: {
    fontSize: 10,
    color: '#1976d2',
  },
  negativeChip: {
    backgroundColor: '#ffebee',
  },
  negativeChipText: {
    color: '#d32f2f',
  },
  reactionsContainer: {
    marginTop: 12,
  },
  reactionItem: {
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
    borderLeft: '3px solid #e0e0e0',
    breakInside: 'avoid',
    orphans: 2,
    widows: 2,
  },
  reactionText: {
    fontSize: 11,
    color: '#333333',
    lineHeight: 1.4,
  },
  reactionMeta: {
    fontSize: 9,
    color: '#666666',
    marginTop: 4,
  },
  positiveReaction: {
    borderLeftColor: '#06D6A0',
  },
  neutralReaction: {
    borderLeftColor: '#AAAAAA',
  },
  negativeReaction: {
    borderLeftColor: '#FF6B6B',
  },
  chartContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 100,
    width: '100%',
    marginTop: 4,
    marginBottom: 4,
  },
  chartImage: {
    maxWidth: 100,
    maxHeight: 100,
    width: 100,
    height: 100,
  },
  engagementGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 12,
  },
  engagementItem: {
    backgroundColor: '#f5f5f5',
    borderRadius: 8,
    padding: 12,
    alignItems: 'center',
    minWidth: 80,
  },
  engagementNumber: {
    fontSize: 16,
    fontWeight: 700,
    color: '#333333',
  },
  engagementLabel: {
    fontSize: 10,
    color: '#666666',
    textAlign: 'center',
    marginTop: 4,
  },
  sentimentPercentageBreakdown: {
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 12,
    flex: 1,
  },
  sentimentPercentageRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
    paddingHorizontal: 4,
  },
  sentimentDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 6,
  },
  sentimentPercentageValue: {
    fontSize: 14,
    fontWeight: 600,
    minWidth: 35,
    marginRight: 6,
  },
  sentimentPercentageLabel: {
    fontSize: 10,
    color: '#666666',
  },
  positiveBackground: {
    backgroundColor: '#e8f5e8',
  },
  neutralBackground: {
    backgroundColor: '#f5f5f5',
  },
  negativeBackground: {
    backgroundColor: '#fde8e8',
  },
  defaultBackground: {
    backgroundColor: '#ffffff',
  },
  pageBreak: {
    breakAfter: 'page',
  },
  reactionsPageContainer: {
    paddingBottom: 40,
    marginTop: 20,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: 'column',
    paddingTop: 10,
    borderTop: '1px solid #e0e0e0',
  },
  footerMain: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  footerText: {
    fontSize: 10,
    color: '#666666',
  },
  footerLink: {
    fontSize: 10,
    color: '#1976d2',
    textDecoration: 'none',
  },
  footerCenter: {
    fontSize: 10,
    color: '#666666',
  },
  aiDisclaimer: {
    fontSize: 6,
    color: '#999999',
    textAlign: 'center',
    lineHeight: 1.3,
    fontStyle: 'italic',
  },
});